import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "w100 headline-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", { class: "headline-5" }, "Articles for You", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_back_button = _resolveComponent("back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_notification_bell = _resolveComponent("notification-bell")!
  const _component_fav_modal_button = _resolveComponent("fav-modal-button")!
  const _component_help_button = _resolveComponent("help-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_latest_check_in_swiper = _resolveComponent("latest-check-in-swiper")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_trend_block = _resolveComponent("trend-block")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_skeleton_feed = _resolveComponent("skeleton-feed")!
  const _component_articles_feed = _resolveComponent("articles-feed")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_resources_in_area = _resolveComponent("resources-in-area")!
  const _component_upcoming_events_box = _resolveComponent("upcoming-events-box")!
  const _component_sidebar_box = _resolveComponent("sidebar-box")!
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")!
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { onClick: _ctx.scrollTop }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, {
                slot: "start",
                class: "ion-hide-lg-up"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_back_button)
                ]),
                _: 1
              }),
              (!_ctx.loading)
                ? (_openBlock(), _createBlock(_component_ion_buttons, {
                    key: 0,
                    slot: "end"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_notification_bell, {
                        parent: _ctx.$parent!.$refs.ionRouterOutlet
                      }, null, 8, ["parent"]),
                      _createVNode(_component_fav_modal_button, {
                        parent: _ctx.$parent!.$refs.ionRouterOutlet
                      }, null, 8, ["parent"]),
                      _createVNode(_component_help_button)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { ref: "content" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_refresher, {
            slot: "fixed",
            onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadData($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_refresher_content)
            ]),
            _: 1
          }),
          _createVNode(_component_ion_grid, { class: "w100" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_grid, { class: "w100" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_row, { class: "mx-4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, {
                                "size-lg": "6",
                                size: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_latest_check_in_swiper)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                "size-lg": "6",
                                size: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("h5", _hoisted_1, _toDisplayString(_ctx.trendsLength > 6 ? 7 : _ctx.trendsLength) + " Day Trend ", 1),
                                  _createVNode(_component_ion_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_col, {
                                        "size-sm": "12",
                                        size: "12"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_trend_block, {
                                            class: "auto",
                                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/home/bio'))),
                                            category: "biological",
                                            label: "Biological",
                                            color: "153, 202, 60"
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_col, {
                                        "size-sm": "12",
                                        size: "12"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_trend_block, {
                                            class: "auto",
                                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/home/psych'))),
                                            category: "psychological",
                                            label: "Psychological",
                                            color: "88, 196, 235"
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_col, {
                                        "size-sm": "12",
                                        size: "12"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_trend_block, {
                                            class: "auto",
                                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/home/social'))),
                                            category: "social",
                                            label: "Social",
                                            color: "244, 123, 75"
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_col, {
                                        "size-sm": "12",
                                        size: "12"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_trend_block, {
                                            class: "auto",
                                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/home/spirit'))),
                                            category: "spiritual",
                                            label: "Spiritual",
                                            color: "154, 87, 163"
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, { class: "ion-justify-content-center px-4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, {
                                "size-lg": "12",
                                "size-md": "12",
                                size: "12"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_2
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, { class: "ion-justify-content-center px-2 mx-1" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, {
                                "size-lg": "12",
                                "size-md": "12",
                                size: "12"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.loading)
                                    ? (_openBlock(), _createBlock(_component_skeleton_feed, { key: 0 }))
                                    : _createCommentVNode("", true),
                                  (!_ctx.loading)
                                    ? (_openBlock(), _createBlock(_component_articles_feed, {
                                        key: 1,
                                        dashboard: true
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.innerWidth > 1400)
                    ? (_openBlock(), _createBlock(_component_ion_col, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_sidebar_box, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_resources_in_area),
                              _createVNode(_component_upcoming_events_box, { class: "mt-2" })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_infinite_scroll, {
            onIonInfinite: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadData($event, true))),
            threshold: "100px",
            id: "infinite-scroll"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_infinite_scroll_content, { "loading-spinner": "crescent" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }))
}